module.exports = __webpack_public_path__ + "f073d755d3a4f1c552ab4f116207fc32.svg";